// extracted by css-extract-rspack-plugin
export default {"cls1":"Cta-cls1_JaE","cls2":"Cta-cls2_gVE Cta-cls1_JaE"};